'use client';

import React, { useEffect, useState } from 'react';
import { SearchInput } from '@/components/ui/search-input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { apiSwaggerClientSide } from '@/shared/api';
import { Group } from '@/sharedTypes/Api';
import { CatalogueFilters } from '../views/CatalogueTableView';

export const ACCESS_OPTIONS = [
  { value: 'public', label: 'Public' },
  { value: 'restricted', label: 'Restricted' },
  { value: 'hidden', label: 'Hidden' }
];

interface FiltersProps {
  filters: CatalogueFilters;
  onFilterChange: (key: keyof CatalogueFilters, value: string) => void;
}

const Filters = ({ filters, onFilterChange }: FiltersProps) => {
  const [groups, setGroups] = useState<Group[]>([]);
  const [loadingGroups, setLoadingGroups] = useState(true);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = await apiSwaggerClientSide.admin.groupsList();
        if (response.data?.success && response.data.data) {
          setGroups(response.data.data);
        }
      } catch (error) {
        console.error('Failed to fetch groups:', error);
      } finally {
        setLoadingGroups(false);
      }
    };
    fetchGroups();
  }, []);

  return (
    <div className="flex gap-3 w-full mb-2">
      {/* Search input - ~35% */}
      <div className="basis-[35%]">
        <SearchInput
          value={filters.search}
          onChange={(e) => onFilterChange('search', e.target.value)}
          placeholder="Search samples by name..."
          className="w-full"
          inputClassName="h-9"
        />
      </div>

      {/* Access type select - ~35% */}
      <div className="basis-[35%]">
        <Select
          value={filters.visibility}
          onValueChange={(value) => onFilterChange('visibility', value)}
        >
          <SelectTrigger className="w-full bg-white">
            <SelectValue placeholder="Access type" />
          </SelectTrigger>
          <SelectContent>
            {ACCESS_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Group select - remaining space */}
      <div className="flex-1">
        <Select
          value={filters.group}
          onValueChange={(value) => onFilterChange('group', value)}
          disabled={loadingGroups}
        >
          <SelectTrigger className="w-full bg-white">
            <SelectValue placeholder={loadingGroups ? 'Loading...' : 'Select group'} />
          </SelectTrigger>
          <SelectContent>
            {groups.map((group) => (
              <SelectItem key={group._id} value={group._id!}>
                {group.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default Filters;
